<template lang="pug">
#bloco-inserir-dados-contrato-originacao-planilha
    h1 Inserir dados do contrato de originação via planilha
    el-card
        .box-card-inserir-dados-planilha
            .box-card-inserir-dados-planilha__conteudo
                .box-card-inserir-dados-planilha__conteudo__bloco
                    span Para agilizar seu processo, você pode adicionar os imóveis de uma vez só atravez de uma planilha. <br> Ela deve conter os seguintes campos:

                .box-card-inserir-dados-planilha__conteudo__bloco
                    .box-card-inserir-dados-planilha__conteudo__bloco__lista
                        ul
                            li CAR
                            li Volume
                            li CPF/CNPJ (opcional)

                .box-card-inserir-dados-planilha__conteudo__bloco
                    span você támbem pode utilizar o modelo de planilha disponível abaixo:

                .box-card-inserir-dados-planilha__conteudo__bloco
                    .box-card-inserir-dados-planilha__conteudo__bloco__buttons
                        BaseButton(icon='el-icon-download', @click='') Baixar modelo CSV
                        el-upload.upload-demo(
                            action='#',
                            :auto-upload='false'
                            :on-change='enviarPlanilha',
                            :on-exceed='onExceed',
                            :limit='1',
                            ref='uploadPlanilhaTerritorio'
                        )
                            BaseButton(icon='el-icon-upload2' type='primary') Inserir Planilha
                            .el-upload__tip(slot='tip') xlsx files with a size less than 500kb
</template>

<script>
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'BlocoInserirDadosPlanilha',
    components: {
        BaseButton
    },
    data() {
        return {
            dadosLote: null
        };
    },

    methods: {
        onExceed() {
            this.$notify.warning({
                message: 'Só é permitido o upload de um arquivo por vez.',
                position: 'top-left'
            });
        },

        async enviarPlanilha(planilha) {
            if (this.dadosLote && this.dadosLote.statusCodigo === 'EM_PROCESSAMENTO') {
                this.$notify.warning({
                    message: 'Não é possivel realizar um novo cadastro, pois existe um em processamento.'
                });
                this.$refs.uploadPlanilhaTerritorio.clearFiles();
                return false;
            }

            if (planilha.size > 15000000) {
                this.$notify.warning({
                    message: 'Esse arquivo ultrapassa 15MB.'
                });
                this.$refs.uploadPlanilhaTerritorio.clearFiles();
                return false;
            }

            let extension = planilha.name.split('.').pop().toLowerCase();
            if (extension !== 'xlsx') {
                this.$notify.error({
                    message: 'Apenas arquivos com a extensão XLSX são suportados.'
                });
                this.$refs.uploadPlanilhaTerritorio.clearFiles();
                return false;
            }

            try {
                this.$notify.success({
                    message: 'Arquivo está sendo enviado.'
                });
                await ContratoOriginacaoService.cadastrarTerritoriosViaPlanilha(planilha);
                this.$notify.success({
                    message: 'Arquivo enviado com sucesso. O processamento será concluído em breve.'
                });
                // this.buscarDadosLote();
            } catch (error) {
                this.$notify.error({
                    message: 'Erro ao realizar upload do arquivo.'
                });
            }
            this.$refs.uploadPlanilhaTerritorio.clearFiles();
        }
    }
};
</script>

<style lang="scss" scoped>
#bloco-inserir-dados-contrato-originacao-planilha {
    width: 100%;

    h1,
    ul {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
    }

    .el-card.is-always-shadow {
        min-height: 180px;
    }

    el-card {
        margin-top: 10px;
    }

    .box-card-inserir-dados-planilha__conteudo {
        display: flex;
        flex-direction: column;

        .box-card-inserir-dados-planilha__conteudo__bloco {
            margin-bottom: 15px;
            display: flex;
            .box-card-inserir-dados-planilha__conteudo__bloco__buttons {
                display: flex;
                justify-content: space-between;
                gap: 15px;
                width: 100%;
            }
        }
    }
}
</style>
